import { REQUEST_STATUSES } from "@/constants/index.js";
import { FlagService } from "@/services";

import { GET_FLAGS, SET_FLAGS_REQUEST_STATUS } from "./types.js";

export const getFlags = (query) => {
  return async (dispatch) => {
    dispatch({
      payload: { status: REQUEST_STATUSES.LOADING },
      type: SET_FLAGS_REQUEST_STATUS,
    });

    const { resp, status, err } = await FlagService.getFlags(query);

    dispatch({
      payload: { flags: resp?.data || [], status, err, query },
      type: GET_FLAGS,
    });
  };
};
